class collectionFilters extends HTMLElement {
  constructor() {
    super()
    this.filters = this.querySelector('#collection-filters');
    if ( this.filters) {
      this.filters.addEventListener('scroll', ()=> {
        this.handleScroll();
      })
    }
  }

  handleScroll() {
    const scrollEnd = this.filters.scrollWidth - this.filters.clientWidth;
    if(this.filters.scrollLeft === 0) {
      this.classList.add('on-start');
      this.classList.remove('scrolling');
      this.classList.remove('on-end');
    } else if (this.filters.scrollLeft > 10 && this.filters.scrollLeft < scrollEnd - 10) {
      this.classList.remove('on-start');
      this.classList.add('scrolling');
      this.classList.remove('on-end');
    } else if (this.filters.scrollLeft >= scrollEnd - 10){
      this.classList.remove('on-start');
      this.classList.remove('scrolling');
      this.classList.add('on-end');
    }
  }
}

customElements.define('collection-filters', collectionFilters)